<template>
	<div id="company-card-main">
		<bread-crumbs
			v-if="activeTab === 0"
			:title="$t('TypeConfig')"
			:subTitle="$t('general.SubtitleTypeConfig')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<div :class="activeTab === 0 ? 'vx-card p-4' : ''">
			<div v-if="activeTab === 0" class="tab-text">
				<type-config-crud-list-view
					v-if="typeConfigReadPermission"
					:data="companyData"
					@selectedCompanyEmit="selectedCompanyEmit"
					@valueCreateTypeConfig="valueCreateTypeConfigEmit"
				/>
				<not-permission v-else></not-permission>
			</div>
			<div v-else-if="activeTab === 1" class="tab-text">
				<template>
					<bread-crumbs
						class="ml-1"
						:title="
							company.type_config_id !== 0
								? $t('Crud.Update') + ' ' + $t('TypeConfig')
								: $t('New') + ' ' + $t('TypeConfig')
						"
						:subTitle="
							company.type_config_id !== 0
								? $t('TypeConfigCrudFormTitleEdit')
								: $t('TypeConfigCrudFormTitleCreate')
						"
						:sizeTitle="22"
						:lineHeightTitle="27"
						:sizeSubTitle="13"
						:lineHeightSubTitle="16"
					>
					</bread-crumbs>
					<div class="vx-row mb-2">
						<div class="vx-col w-full flex items-center">
							<feather-icon
								class="g-breadcrumb--title"
								icon="ChevronLeftIcon"
								svgClasses="h-8 w-8"
								@click.prevent="valueCreateTypeConfigEmit(0)"
							/>
							<vs-breadcrumb
								class="g-breadcrumb--title"
								separator=""
								:items="[{title: $t('general.Return')}]"
								@click.prevent="valueCreateTypeConfigEmit(0)"
							></vs-breadcrumb>
						</div>
					</div>
				</template>
				<configuration-design
					v-if="typeConfigCreatePermission && this.typeConfiguration.id == 0"
					:schema="typeConfiguration"
					@changeActiveTabEmit="changeActiveTab"
					@consultTypeConfigEmit="consultTypeConfig"
				/>

				<configuration-design
					v-else-if="typeConfigUpdatePermission && this.typeConfiguration.id !== 0"
					:schema="typeConfiguration"
					@changeActiveTabEmit="changeActiveTab"
					@consultTypeConfigEmit="consultTypeConfig"
				/>
				<not-permission v-else></not-permission>
			</div>
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import CompanyConf from "@/models/CompanyConf.js";

import TypeConfigCrudListView from "./TypeConfigCrudListView.vue";
import moduleTypeConfigCrud from "@/store/type-config-crud/moduleTypeConfigCrud.js";
import NotPermission from "@/views/pages/NotPermission.vue";
import ConfigurationDesign from "./ConfigurationDesign.vue";

import TypeConfiguration from "../../models/TypeConfiguration";

export default {
	name: "TypeConfigCrud",
	data() {
		return {
			company: new CompanyConf({}),
			companyData: {},
			activeTab: 0,
			typeConfiguration: new TypeConfiguration({}),
		};
	},
	components: {
		TypeConfigCrudListView,
		NotPermission,
		ConfigurationDesign,
	},
	computed: {
		typeConfigReadPermission() {
			return this.$store.getters.checkPermission("TYPE_CONFIG_R");
		},
		typeConfigCreatePermission() {
			return this.$store.getters.checkPermission("TYPE_CONFIG_C");
		},
		typeConfigUpdatePermission() {
			return this.$store.getters.checkPermission("TYPE_CONFIG_U");
		},
	},
	methods: {
		// Seleccion de editar
		selectedCompanyEmit(val) {
			this.typeConfiguration = new TypeConfiguration(val);
			this.activeTab = 1;
		},
		// Cambiar tab actual
		changeActiveTab(tabNum) {
			this.activeTab = tabNum;
			this.company = new CompanyConf(0, {});
			this.typeConfiguration = new TypeConfiguration({});
		},
		loading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		consultTypeConfig() {
			this.loading();
			// Consulta los tipos de configuración existentes
			this.$store
				.dispatch("moduleTypeConfigCrud/getListConfig")
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		valueCreateTypeConfigEmit(val) {
			this.activeTab = val;
			if (this.activeTab === 0) {
				this.company = new CompanyConf({});
			}
		},
	},
	created() {
		// Se registra el modulo
		if (!moduleTypeConfigCrud.isRegistered) {
			this.$store.registerModule("moduleTypeConfigCrud", moduleTypeConfigCrud);
			moduleTypeConfigCrud.isRegistered = true;
		}

		this.consultTypeConfig();
	},
};
</script>
